module.exports = global["jQuery"] = require("-!/u/apps/rep.co_staging/shared/node_modules/expose-loader/index.js?$!./jquery.js");